export enum ScrollToAnchorId {
	PDP_DESCRIPTION = 'pdp-description',
	PDP_TECHNOLOGIES = 'pdp-technologies',
}
